<template>
    <div id="svote">
        <top :title="title"></top>
        <div class="setFix"></div>
        <div class="tpBox">
            <div class="iptBox">
                <input type="text" class="ipt" placeholder="请输入投票标题" v-model="form.title">
                <textarea name="desc" id="" cols="15" rows="5" placeholder="请输入投票描述" class="descContent" v-model="form.info"></textarea>
                <ul>
                    <li v-for="(item,i) in tpObj" class="wtag">
                        <input type="text" v-model="item.title" placeholder="请输入选项名">
                        <img class="del" src="@/assets/imgs/del.png" alt="" @click="delCur(i)">
                    </li>
                    <li @click="addList">添加选项<img class="del" src="@/assets/imgs/ad.png" alt=""></li>
                </ul>
            </div>
        </div>
        <!-- 截止日期 -->
        <div class="endDate" @click="chioceTime2">
            截止日期
            <span class="dtime">{{end_time}}</span>
        </div>
        <a href="javascript:;" class="done" @click="doneAdd">完成</a>
        <!-- 选择截止日期 -->
        <mt-datetime-picker
            ref="picker2"
            type="datetime"
            year-format="{value} 年"
            month-format="{value} 月"
            date-format="{value} 日"
            hour-format="{value} 时"
            minute-format="{value} 分"
            :startDate="startDateval2"
            :endDate="endDate2"
            @confirm="getTimeval2">
        </mt-datetime-picker>
    </div>
</template>
<script>
import Top from "@/component/top/top";
import { MessageBox, Toast } from 'mint-ui';
import axios from 'axios'
import moment from 'moment'
export default {
    components:{
        Top
    },
    data() {
        return {
            tpObj:[
                {title:''},
                {title:''}
            ],
            form:{
                info:'',
                title:''
            },
            end_time:'请选择',
            title:'',
            type:'',
            desc:'物业',
            startDateval2:new Date(),
            endDate2: moment().add(6, 'month').toDate(),
        }
    },
    created() {
        this.title = this.$route.query.title
        if(this.title == '创建单选投票') {
            this.type = 0
        }else{
            this.type = 1
        }
    },
    mounted(){
        // this.setuserToken('H88YDuXYuaPjfK5unxUj5JGFD8YizaE8')
        // 安卓ios/移动端获取token
        //配置默认参数
        if(this.isAndroid()) {
            window.app.postToken('postToken')
            window["getToken"] = token => {
                this.setuserToken(token)
            }
        }else if(this.isIos()) {
            window.webkit.messageHandlers.postToken.postMessage('')
            window.getToken = this.getToken
        } else {
            this.getUser()
        }
    },
    methods:{
        postToken() {

        },
        getToken(token) {
            this.setuserToken(token)
        },
        getUser() {
            axios.post(this.commonIp()+'/v1/mobile/community/userInfo')
            .then((res) => {
                if(res.data.code=='200') {
                    this.setuserToken(res.data.data.token)
                }else if(res.data.code == '424'||res.data.code == '423'){
                    if (this.isAndroid() || this.isIos()) {
                        window.location.href = "app://login";
                    } else {
                        // lng=116.467125&lat=39.996747
                        window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
                    }
                }
            })
        },
        addList() {
            this.tpObj.push({title:''})
        },
        // 删除当前选项
        delCur(i) {
            if(i==0 || i==1) {
                Toast("最少有2个选项")
            }else{
                this.tpObj.splice(i,1)
            }
        },
        chioceTime2() {
            this.$refs.picker2.open();
        },
        getTimeval2(val) {
            this.end_time = moment(val.getTime()).format('YYYY-MM-DD HH:mm')
        },
        // 点击完成
        doneAdd() {
            for(let item of this.tpObj) {
                if(!item.title) {
                    Toast("请输入选项名")
                    return
                }
            }
            if(this.end_time=='请选择') {
                Toast('请选择截止时间')
            }else{
                // 发起投票
                axios.post(this.commonIp()+'/v1/polls',{
                    token:this.getuserToken(),
                    title:this.form.title,
                    info:this.form.info,
                    end_time:this.end_time,
                    options:this.tpObj,
                    // 1多选0单选
                    type:this.type
                }).then((res) => {
                    if(res.data.code==200) {
                        // 区分移动端/客户端
                        let params = {id:res.data.data.poll._id,title:res.data.data.poll.title}
                        if (this.isAndroid()) {
                            window.app.getPollParams(JSON.stringify(params));
                        }else if (this.isIos()) {
                            window.webkit.messageHandlers.getPollParams.postMessage(
                                params
                            );
                        }else{
                            if(this.myCommon.isIframe()) {
                                Toast("成功跳转到客户端列表")
                            }else{
                                window.parent.getPollParams(params)
                            }
                        }
                    }else{
                        Toast(res.data.message)
                    }
                })
            }
        }
    }
}
</script>
<style lang="less">
@import "~@/assets/less/index.less";
.mint-msgbox-confirm{
    color:#25cf8d;
    border-left:1px solid #f2f2f2;
}
#svote{
    background:#f2f2f2;
    width: 100%;
    height: 100%;
    .picker-item{
        padding:0 2px;
    }
    .descContent{
        border:0;
        width:100%;
        padding:15px 0 15px 0;
        font-family: '微软雅黑';
        border-bottom:1px solid #d8d8d8;
        &:focus{
            outline: none;
        }
    }
    .mint-datetime-action{
        color:#25cf8d;
    }
    #headers{
        border-bottom:1px solid #d8d8d8;
    }
    .endDate{
        line-height: 50px;
        background: #fff;
        margin:10px 0 30px;
        padding:0 15px;
        .dtime{
            .fr();
        }
    }
    .scTp{
        margin:45px 0;
        text-align: center;
        font-size:@ft14;
        color:#969696;
    }
    .done{
        width:90%;
        margin:0 auto;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color:#fff;
        display: block;
        background: #25cf8d;
        border-radius: 5px;
    }
    .tpBox{
        .iptBox{
            background: #fff;
            position: relative;
            padding:0 15px;
            -webkit-user-select:text !important;
            .ipt{
                height: 55px;
                border:0;
                border-bottom:1px solid #d8d8d8;
                width:100%;
                &:focus{
                    outline: none;
                }
            }
            li{
                margin:0 0 0 33px;
                border-bottom:1px solid #d8d8d8;
                position: relative;
                height: 50px;
                line-height: 50px;
                input{
                    width: 100%;
                    height: 96%;
                    display: inline-block;
                    border:0;
                    &:focus{
                        outline: none;
                    }
                }
                &:last-child{
                    border-bottom:0;
                    color:#25cf8d;
                }
                .del{
                    width:18px;
                    position: absolute;
                    left:-30px;
                    top:16px;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/svote/svote.vue